"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endsWithMatcherContext = void 0;
var lang_1 = require("../../utils/lang");
function endsWithMatcherContext(ruleAttr) {
    return function endsWithMatcher(runtimeAttr) {
        var strEndsWith = ruleAttr.some(function (e) { return (0, lang_1.endsWith)(runtimeAttr, e); });
        return strEndsWith;
    };
}
exports.endsWithMatcherContext = endsWithMatcherContext;
